import {
	Box,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import { sortAmount } from "../../../utils/sort-methods";

import Heading5 from "../../typography/heading-05";

import styles from "./index.module.scss";

const TableHeadEligibleProduct = (props) => {
	const { data, order, orderBy, onRequestSort, rowData, setSortedData } = props;

	const createSortHandler = (property) => (event) => {
		console.log("25 property:", property);
		let fieldId = "";

		let sortedData = sortAmount(rowData, order, fieldId);

		setSortedData(sortedData);
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{data.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
						style={{ minWidth: headCell.minWidth }}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							<Heading5
								text={headCell.label}
								extraClass={styles.thText}
								fontType="semibold"
							/>
							{orderBy === headCell.id ? (
								<Box component="span" sx={visuallyHidden}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
};

export default TableHeadEligibleProduct;
